import React from 'react'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState';
import { useLanguageState } from '../../globalStates/LanguageState';
import Page from '../../components/Page';
import EventDateSection from './EventDateSection';

const EventDatesPage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const eventDatesStates = useExhibitorDataState().getEventDates()

    return (
        <Page
            title={branding.configuration.eventDatesPage.pageTitle}
            description={branding.configuration.eventDatesPage.pageDescription}>
            {eventDatesStates?.map((eventDateState, index) => (<EventDateSection key={eventDateState.id.get()} eventDateState={eventDateState} index={index} />))}
        </Page>
    );
}

export default EventDatesPage